import MainButton, {ButtonWithIcon} from "../forms/Buttons";
import React, {Component} from "react";
import * as PropTypes from "prop-types";
import classNames from 'classnames';
import SelectButtons from "./SelectButtons";
import {Col, Container, Row} from "react-bootstrap";

import '../../../assets/sass/components/select/select-grid.scss';
import Icon from "../Icon";

class SelectGridWithIcon extends SelectButtons {
    render = () => {
        const {options} = this.props;
        return (
            <div className="select-grid with-icon">
                <Container fluid={true}>
                    <Row className="select-grid--row"> {options.map((option, index) => (<Col key={index} xl={4} lg={6} md={6} sm={6} xs={12} className="select-grid--col">  {this.renderOption(option, index)} </Col>))} </Row>
                </Container>
            </div>
        );
    };

    renderOption = (option, index) => {
        const {value} = this.state;
        const {aspectRatio} = this.props;
        const active = option.value === value;
        const {svg, icon, label} = option;

        return (
            <SelectGridWithIcon.item key={index} active={active} text={label} icon={icon} svg={svg} aspectRatio={aspectRatio} onClick={(event) => this.handleSelect(event, option)}/>
        );
    };
}

SelectGridWithIcon.item = props => {
    const {active, aspectRatio, svg, icon, text, onClick} = props;

    return (
        <div className={classNames("select-grid-item with-icon", active ? 'active' : '')} style={{paddingBottom: `${100. / aspectRatio}%`}} onClick={onClick}>
            <div className="select-grid-item--wrapper">
                <Icon className="select-grid-item--icon" svg={svg} icon={icon}/>
                <span className="select-grid-item--text"> {text} </span>
            </div>
        </div>
    );
};

export default SelectGridWithIcon;
